import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6" }
const _hoisted_2 = { class: "text-block" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: "lead mt-2 xyz-in text-dark d-flex align-c",
  xyz: "fade down duration-8 delay-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "triangle bg-primary mr-05" }, null, -1)
const _hoisted_6 = {
  class: "lead mt-3 xyz-in",
  xyz: "fade duration-8 delay-3"
}

import { strings } from '@/strings'
import { locator, ParsedPhoneNumber } from '@/utils/locator'
import { router } from '@/router'
import PhoneInput from '@/components/ui/phone-input.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'hero-content',
  setup(__props) {

const submit = (parsed_number: ParsedPhoneNumber) => {
  // init locator and save parsed number
  locator.init(parsed_number)
  router.push(`/sign-up?d=${encodeURIComponent(parsed_number.dial)}&n=${parsed_number.number}`)
}

// get url arguments
const args = new URLSearchParams(window.location.search)

// get gclid and save if defined
let h1 = strings.core["Slogan"].replace(/^\s*\w+/, '<span class="text-primary">$&</span>')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", {
        class: "xyz-in",
        xyz: "fade down-2 duration-8 delay-1",
        innerHTML: _unref(h1)
      }, null, 8, _hoisted_3),
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_unref(strings).core['PhoneError']), 1)
      ])
    ]),
    _createVNode(PhoneInput, {
      onReady: submit,
      ref: "phone-input",
      btn_text: _unref(strings).core['Start'],
      class: "mt-15 xyz-in",
      xyz: "fade duration-8 delay-3"
    }, null, 8, ["btn_text"]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(strings).core['Description']), 1)
  ]))
}
}

})